import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutGrid, KanbanSquare, Radar, ListChecks, Settings, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const tabs = [
  { to: "/", label: "Today", icon: LayoutGrid, id: "nav-today" },
  { to: "/pipeline", label: "Pipeline", icon: KanbanSquare, id: "nav-pipeline" },
  { to: "/bids", label: "Bids", icon: Radar, id: "nav-bids" },
  { to: "/followups", label: "Follow-ups", icon: ListChecks, id: "nav-followups" },
  { to: "/settings", label: "Settings", icon: Settings, id: "nav-settings" },
];

export default function Layout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col max-w-3xl mx-auto">
      <header className="flex items-center justify-between px-5 h-14 sticky top-0 bg-background/90 backdrop-blur z-40">
        <span className="flex items-center gap-2.5">
          <img src="/tag-logo.png" alt="TAG" className="w-8 h-8 rounded-full object-contain shadow-sm" />
          <span className="font-display text-xl text-primary">TAGCOMMAND</span>
        </span>
        <button
          data-testid="logout-button"
          onClick={() => { logout(); navigate("/login"); }}
          className="text-muted-foreground hover:text-foreground tap-btn"
        >
          <LogOut size={16} />
        </button>
      </header>
      <main className="flex-1 pb-20">
        <Outlet />
      </main>
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card max-w-3xl mx-auto" style={{ boxShadow: "0 -4px 20px rgba(31,61,63,0.08)" }}>
        <div className="grid grid-cols-5">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.to === "/"}
              data-testid={t.id}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-3 text-[10px] uppercase tracking-widest tap-btn ${
                  isActive ? "text-primary font-bold" : "text-muted-foreground"
                }`
              }
            >
              <t.icon size={18} />
              {t.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
